import { Link } from 'react-router-dom'

// The watch feature's own screen-tab row — a coordination note from Jordan,
// via the manager, mid-V2-2b: "the Watch screen tabs are yours to build, as
// one shared component... render it at the top of the Watch panel AND at
// the top of the Archive page."
//
// ═══════════════════════════════════════════════════════════════════════════
// 🔴 ONLY THE TABS WHOSE SCREENS EXIST — the design's own row is Watchlists ·
//    Archive · Leaderboards/stats · Goated, and the note is explicit: show
//    only the tabs whose screen exists. V2-5c added the third, Leaderboards/
//    stats (`/watch/leaderboards`); V2-8c adds the fourth and last, Goated
//    (`/watch/goated`) — every screen the design draws now has a tab.
// ═══════════════════════════════════════════════════════════════════════════
//
// ⚠️ NOT the design's own generic sticky-header shell (RECONCILIATION.md
// item 1) — that carries the wordmark, Wall/Binder/Watch and the Me button,
// none of which this site has. This is a narrower, watch-specific in-page
// control, the same shape `WatchTitle.jsx`'s own season chips already are:
// a small navigational aid scoped to one feature, not the portal's shell.
//
// "Watchlists" always links to `/` — there is no standalone watchlists
// route of its own (the panel lives inside the portal home), the same
// destination every existing "← Watch" back-link in this feature already
// uses (`WatchTitle.jsx`, and this page before this note added the tabs).

const TABS = [
  { key: 'lists', label: 'Watchlists', to: '/' },
  { key: 'archive', label: 'Archive', to: '/watch/archive' },
  { key: 'leaderboards', label: 'Leaderboards/stats', to: '/watch/leaderboards' },
  { key: 'goated', label: 'Goated', to: '/watch/goated' },
]

/**
 * `active` is `'lists'` (the watch panel), `'archive'`, `'leaderboards'` or
 * `'goated'` (this route) — the caller's own job to say, since only the caller knows
 * which page it is inside (this component has no route awareness of its
 * own, deliberately: `WatchPanel.jsx` renders it beside its OWN panel
 * content on `/`, never a standalone route `useLocation()` could read).
 */
export default function WatchScreenTabs({ active }) {
  return (
    <div className="d2d-watchtabs" role="tablist" aria-label="Watch screens">
      {TABS.map((tab) => {
        const isActive = tab.key === active
        return isActive ? (
          <span
            key={tab.key}
            role="tab"
            aria-selected="true"
            className="d2d-watchtabs__tab d2d-watchtabs__tab--active"
            data-testid={`watch-tab-${tab.key}`}
          >
            {tab.label}
          </span>
        ) : (
          <Link
            key={tab.key}
            role="tab"
            aria-selected="false"
            to={tab.to}
            className="d2d-watchtabs__tab"
            data-testid={`watch-tab-${tab.key}`}
          >
            {tab.label}
          </Link>
        )
      })}
    </div>
  )
}
